import store from "../store";
import Utils from "../helpers/utils";
export default class ErrorService {
  static onChatError(errCode, result) {
    if (errCode !== null && errCode !== "") {
      var msg =
        store.getters.widgetData.errorAlerts.errorCode || "Error Code: ";
      this.displayAlert(msg + errCode);
    } else if (result !== null && result.statusText) {
      this.displayAlert(result.statusText);
    }
  }

  static displayAlert(msg = "", type = "error",time = 4000) {
    store.commit(
      "addAlertToArray",
      new Alert(msg, type, type == "error" ? null : (time ? time :4000))
    );
    if (type == "info") {
      Utils.log.info("displayAlert:" + msg.toString());
    } else { 
      Utils.log.error("displayAlert:" + msg.toString())
    };
  }
}

class Alert {
  constructor(msg, type, timeout) {
    this.id = Math.random().toString(36);
    this.text = msg.toString();
    this.type = type;
    if (timeout) {
      this.timeout = timeout;
    }
  }
}
